export const IMAGE_EXTENSIONS = [
  "jpg",
  "png",
  "jpeg",
  "git",
  "svg",
  "webp",
  "tiff",
  "psd",
  "bmp",
  "raw",
];
export const AUDIO_EXTENSIONS = [
  "wav",
  "aifc",
  "aiff",
  "mp3",
  "m4a",
  "mp2",
  "ogg",
];

export const VIDEO_EXTENSIONS = [
  "avi",
  "drc",
  "flv",
  "m2v",
  "m4p",
  "m4v",
  "mkv",
  "mng",
  "mov",
  "mp2",
  "mp4",
  "mpe",
  "mpeg",
  "mpg",
  "mpv",
  "ogg",
  "rm",
  "rmvb",
  "roq",
  "svi",
  "vob",
  "webm",
  "wmv",
  "yuv",
];
